import { Container, styled } from '@mui/material';

const CenterContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export default CenterContainer;
